// @flow
import { connect } from 'react-redux';

import {
  resetDateRange,
  setDateRange,
  setTimeRange,
  setAltitudeRange,
  setAirspaceUseType,
  setIsSRSS,
} from 'actions/filters';

import { toggleHUD, setHUDStep } from 'actions/hud';

import { toggleDrawMode } from 'actions/drawOverlay';

import HUD from './HUD';

const mapStateToProps = ({
  hud,
  browser,

  filters: { dateRange, timeRange, altitudeRange, airspaceUseType, isSRSS },

  drawOverlay: { appInDrawMode, feature, mode },
  flags: { hasSubscription },
}) => ({
  hud,
  browser,

  dateRange,
  timeRange,
  altitudeRange,
  airspaceUseType,
  isSRSS,

  appInDrawMode,
  hasSubscription,

  drawOverlayHasFeature: !!feature,
  drawOverlayMode: mode,
});

const mapDispatchToProps = {
  setHUDStep,
  setAltitudeRange,
  setDateRange,
  setTimeRange,
  setIsSRSS,
  setAirspaceUseType,
  toggleDrawMode,
  toggleHUD,
  resetDateRange,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(HUD);



// WEBPACK FOOTER //
// ./components/HUD/index.js